import React from 'react'
import Banner from '../banner/Banner'
import WhoWeAre from '../WhoWeAre/WhoWeAre'
import WhatWeDo from '../WhatWeDo/WhatWeDo'
import Skills from '../Skills/Skills'
import Affiliations from '../Affiliations/Affiliations'

const HomePage = () => {
  return (
<div style={{ marginTop: "20px" }}>         <>
              <Banner />
              <WhoWeAre />
              <WhatWeDo />
              <Skills />
              <Affiliations />
            </>
    </div>
  )
}

export default HomePage